import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

const inp = "h-10 px-3 rounded-xl border border-[#E5E0D8] text-sm bg-white";

export default function TeamPanel() {
  const [team, setTeam] = useState([]);
  const [f, setF] = useState({ name: "", phone: "", pin: "", order: "" });
  const load = () => api.get("/admin/team").then((r) => setTeam(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const add = async () => {
    try {
      await api.post("/admin/team", { ...f, order: parseInt(f.order || "0", 10) });
      setF({ name: "", phone: "", pin: "", order: "" });
      toast.success("CHELA added. Share the app link and PIN with them.");
      load();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Could not add"); }
  };
  const edit = async (id, body) => {
    try { await api.post(`/admin/team/${id}/edit`, body); load(); toast.success("Saved"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Could not save"); }
  };
  const del = async (id) => {
    if (!window.confirm("Remove this CHELA from the team?")) return;
    await api.delete(`/admin/team/${id}`); load();
  };
  const appLink = `${window.location.origin}/chela`;

  return (
    <div className="space-y-5" data-testid="team-panel">
      <div className="chela-card rounded-2xl p-5 space-y-3" style={{ transform: "none" }}>
        <div className="font-display font-bold text-lg">Add a CHELA</div>
        <p className="text-sm text-[#5A5D65]">Paid bookings ring on the CHELA app in this order (lowest number first). If someone doesn't accept within 10 minutes or declines, the job passes to the next person automatically.</p>
        <div className="flex flex-wrap gap-2">
          <input data-testid="team-name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} placeholder="Name" className={inp} />
          <input data-testid="team-phone" value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value.replace(/\D/g, "").slice(0, 10) })} placeholder="Mobile (10 digits)" className={inp} />
          <input data-testid="team-pin" value={f.pin} onChange={(e) => setF({ ...f, pin: e.target.value.replace(/\D/g, "").slice(0, 6) })} placeholder="PIN (4-6 digits)" className={inp} />
          <input data-testid="team-order" value={f.order} onChange={(e) => setF({ ...f, order: e.target.value.replace(/\D/g, "") })} placeholder="Order (1, 2, 3)" className={`${inp} w-32`} />
          <button data-testid="team-add" onClick={add} className="h-10 px-5 rounded-full bg-[#121316] text-white text-sm font-bold">Add</button>
        </div>
        <div className="text-sm">CHELA app link: <b data-testid="team-app-link">{appLink}</b>
          <button onClick={() => { navigator.clipboard?.writeText(appLink); toast.success("Copied"); }} className="ml-2 underline text-[#E05624] font-bold">Copy</button></div>
      </div>
      {team.length === 0 && <p className="text-[#5A5D65]">No CHELAs added yet.</p>}
      {team.map((m) => (
        <div key={m.id} data-testid={`team-member-${m.id}`} className="chela-card rounded-2xl p-5 flex flex-wrap items-center gap-3 justify-between" style={{ transform: "none" }}>
          <div>
            <div className="font-display font-bold text-lg">#{m.order} · {m.name} {!m.active && <span className="text-xs text-[#C0392B]">(off)</span>}</div>
            <div className="text-sm text-[#5A5D65]">{m.phone} · Jobs done: {m.jobs_done} · {m.push ? "Notifications ON" : "Notifications OFF"}</div>
            {m.payout_due > 0 && <div className="text-sm font-bold text-[#E05624]">To pay: ₹{m.payout_due}</div>}
          </div>
          <div className="flex flex-wrap gap-2">
            <button data-testid={`team-toggle-${m.id}`} onClick={() => edit(m.id, { active: !m.active })} className="h-9 px-4 rounded-full border border-[#E5E0D8] text-xs font-bold bg-white">{m.active ? "Mark unavailable" : "Mark available"}</button>
            <button onClick={() => { const o = window.prompt("New order number", m.order); if (o !== null) edit(m.id, { order: parseInt(o, 10) || 0 }); }} className="h-9 px-4 rounded-full border border-[#E5E0D8] text-xs font-bold bg-white">Change order</button>
            <button onClick={() => { const p = window.prompt("New PIN (4-6 digits)"); if (p) edit(m.id, { pin: p }); }} className="h-9 px-4 rounded-full border border-[#E5E0D8] text-xs font-bold bg-white">Reset PIN</button>
            <button data-testid={`team-delete-${m.id}`} onClick={() => del(m.id)} className="h-9 px-4 rounded-full text-xs font-bold text-[#C0392B]">Remove</button>
          </div>
        </div>
      ))}
    </div>
  );
}
